import { useEffect, useMemo, useState } from 'react';
import { NOT_LOGGED_IN_USER_ID } from '../constants';
import { cleanToken, getRemainingSeconds } from '../internals';
import { TokenService } from '../TokenService';
import { tokenContext } from './tokenContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandaloneTokenProvider = ({
  children,
  token,
  customerId
}) => {
  const [clientToken, setClientToken] = useState(token ? cleanToken(token) : undefined);
  const [isAnonymous, setIsAnonymous] = useState(true);
  useEffect(() => {
    if (token) {
      setClientToken(token);
    } else {
      const fetchToken = async () => {
        const fetchedToken = await TokenService.getInstance().getAuthorizationToken(customerId);
        setClientToken(fetchedToken);
      };
      fetchToken().catch(error => {
        console.log(`Some error occured: ${error}`);
        setClientToken('');
      });
    }
  }, [customerId, token]);
  useEffect(() => {
    if (customerId === NOT_LOGGED_IN_USER_ID) {
      setIsAnonymous(true);
    } else {
      setIsAnonymous(false);
    }
  }, [customerId]);
  useEffect(() => {
    const remainder = getRemainingSeconds(clientToken ?? '');

    // in the future, we will want to refresh the token here when the token is about to expire; for now, we are just writing a warning to the console.
    const timer = setTimeout(() => {
      console.warn('Your access token has expired. Please reload the page to acquire a new one.');
    }, remainder * 1000);
    return () => clearTimeout(timer);
  }, [clientToken]);
  const tokenValue = cleanToken(clientToken ?? '');
  const contextValue = useMemo(() => ({
    token: tokenValue,
    customerId,
    formattedToken: tokenValue ? `Bearer ${tokenValue}` : '',
    isAnonymousUser: isAnonymous
  }), [customerId, isAnonymous, tokenValue]);
  return /*#__PURE__*/_jsx(tokenContext.Provider, {
    value: contextValue,
    children: children
  });
};
//# sourceMappingURL=StandaloneTokenProvider.js.map